<h2 class="iackathon-step-final-idea__title">
    {{'iackathon.final_idea_short' | translate}}
</h2>

<p class="iackathon-step-final-idea__text"
   [class.iackathon-step-final-idea__text--no-data]="!finalIdea()">
    {{ finalIdea() ?? ('iackathon.no_idea' | translate) }}
</p>